import { GpxPoint } from './types';

interface GpxMetadata {
  name?: string;
  // Add other potential metadata fields here if needed, e.g., description, time
}

/**
 * Reconstructs a GPX XML string from an array of GpxPoint objects.
 * 
 * @param points - Array of GpxPoint objects, expected to have lat, lon, and optionally ele.
 * @param metadata - Optional metadata for the GPX file (e.g., track name).
 * @returns A string containing the GPX XML.
 */
export function reconstructGpx(points: GpxPoint[], metadata?: GpxMetadata): string {
  const trackName = metadata?.name || 'Augmented Track';

  // Start GPX structure
  let gpxString = `<?xml version="1.0" encoding="UTF-8" standalone="no" ?>
<gpx version="1.1" creator="gpx-elevation-tool" 
     xmlns="http://www.topografix.com/GPX/1/1" 
     xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" 
     xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd">
`;

  // Add Metadata
  gpxString += '  <metadata>\n';
  gpxString += `    <name>${escapeXml(trackName)}</name>\n`;
  // Add timestamp for creation
  gpxString += `    <time>${new Date().toISOString()}</time>\n`;
  gpxString += '  </metadata>\n';

  // Add Track
  gpxString += '  <trk>\n';
  gpxString += `    <name>${escapeXml(trackName)}</name>\n`;
  gpxString += '    <trkseg>\n';

  // Add Track Points
  points.forEach(point => {
    gpxString += `      <trkpt lat="${point.lat.toFixed(6)}" lon="${point.lon.toFixed(6)}">\n`;
    if (point.ele !== undefined) {
      gpxString += `        <ele>${point.ele.toFixed(2)}</ele>\n`; // Keep reasonable precision for elevation
    }
    // If point.time existed and was preserved, it would be added here:
    // if (point.time) {
    //   gpxString += `        <time>${escapeXml(point.time)}</time>\n`;
    // }
    gpxString += '      </trkpt>\n';
  });

  // Close tags
  gpxString += '    </trkseg>\n';
  gpxString += '  </trk>\n';
  gpxString += '</gpx>\n';

  return gpxString;
}

/**
 * Basic XML escaping for content.
 */
function escapeXml(unsafe: string): string {
    return unsafe.replace(/[<>&'"]/g, function (c) {
        switch (c) {
            case '<': return '&lt;';
            case '>': return '&gt;';
            case '&': return '&amp;';
            case '\'': return '&apos;';
            case '"': return '&quot;';
            default: return c; // Should not happen based on regex
        }
    });
} 